import { Table, TableHeader } from '@/components/ui/Table';

import type { ReactNode } from 'react';

export const ScrollableTable = ({
  header,
  children,
  maxHeight = 'max-h-[25rem]',
}: {
  header: ReactNode;
  children: ReactNode;
  maxHeight?: string;
}) => (
  <div className="overflow-hidden rounded-xl border border-border dark:border-border-strong">
    <Table wrapperClassName={maxHeight}>
      <TableHeader className="sticky top-0 z-10 bg-surface-active">
        {header}
      </TableHeader>
      {children}
    </Table>
  </div>
);
